module.exports = __webpack_public_path__ + "static/img/block01.b8574aa8.png";